import { SplitModuleFields, TCarouselItemProps, TSplitModuleProps } from '../types/splitModule.types';
import { ImageField, LinkField, StringField, THeadingTag, VideoSitecoreField } from '../../../types/types';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { getImageField } from '../../../utils/getImageFields';
import { TMediaCarouselSlide } from '../../@shared/mediaCarousel/types/mediaCarousel.types';

export class SplitModuleModel {
  private readonly fields?: SplitModuleFields;
  private readonly params?: ComponentParamsGeneral;
  private readonly _id: string;

  constructor(props: TSplitModuleProps) {
    this.fields = props?.fields;
    this.params = props?.params;
    this._id = props?.id ?? props?.dataSource ?? '';
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }

  get id(): string {
    return this._id;
  }

  get bodyText(): StringField | undefined {
    return this.fields?.bodyText;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get link1(): LinkField | undefined {
    return this.fields?.link1;
  }

  get link2(): LinkField | undefined {
    return this.fields?.link2;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get videoHeading(): StringField | undefined {
    return this.fields?.videoHeading;
  }

  get videoSubheading(): StringField | undefined {
    return this.fields?.videoSubHeading;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  get video(): VideoSitecoreField | undefined {
    return this.fields?.video;
  }

  get useVideo(): boolean {
    return this.fields?.useVideo?.value || false;
  }

  get imagePosition(): 'left' | 'right' {
    return this.params?.imagePosition;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get carouselSlide(): TCarouselItemProps[] {
    return this.fields?.items || [];
  }

  get slides(): TMediaCarouselSlide[] {
    return this.carouselSlide?.map(({ fields }) => {
      const { thumbnailImgSrc } = getThumbnailProps(fields?.video?.value?.href || '');
      const desktopImage = getImageField(fields?.image, thumbnailImgSrc || '', fields?.useVideo?.value);
      const mobileImage = getImageField(fields?.mobileImage, thumbnailImgSrc || '', fields?.useVideo?.value);
      const desktopTransformation = 'Size1000';
      const mobileTransformation = 'Size500';

      return {
        isVideo: fields?.useVideo?.value,
        videoUrl: fields?.video,
        editorialImageProps: {
          desktopImage: desktopImage,
          mobileImage: mobileImage,
          mobileTransformation: mobileTransformation,
          desktopTransformation: desktopTransformation,
        },
      };
    });
  }
}
